
App.factory('BriefcaseNavigation', BriefcaseNavigation);
function BriefcaseNavigation(UserConstants) {
    var serviceObj = {};
    serviceObj.navigate = Navigate;
    function Navigate(minStep, currentStep) {
        console.log("minstep , currentStep", minStep, currentStep);
        let route = "dashboard.profile";
        let redirectStep = currentStep && minStep ? (minStep > currentStep ? currentStep : minStep) : 0;

        switch (redirectStep) {
            case 0:
                route = 'dashboard.profile';
                break;
            case 1:
                route = 'dashboard.license';
                break;
            case 2:
                route = 'dashboard.education';
                break;
            case 3:
                route= 'dashboard.tasks'
                break;
            case 4:
                route = 'dashboard.documents';                
            default:
                break;
        }

        return route;
    }

    return serviceObj;
}